module.exports = __webpack_public_path__ + "static/media/RMG_Logo.254c75f7.jpg";